/* eslint-disable security/detect-object-injection */
import * as React from 'react';
import { Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

import { FormContext } from '@/helper/context';
import { camelToTitle } from '@/helper/utility';

interface Option {
  key: string;
  value: string;
}

interface Properties {
  name: string;
  list: Option[];
  displayName?: string;
  size?: string;
  value?: string[];
  valueSelect?: string[];
  showLabel?: boolean;
}

export function SelectorListMultiple({
  name,
  list,
  displayName,
  size = 'col-12',
  value,
  valueSelect,
  showLabel = true
}: Properties) {
  const resolvedDisplayName = displayName || camelToTitle(name);
  const initial = valueSelect ?? value ?? [];
  const [selected, setSelected] = React.useState<Option[]>(list.filter((option) => initial.includes(option.key)));
  const { changeTracker, setWasChanged, disabled, errors } = React.useContext(FormContext);

  React.useEffect(() => {
    const didChange = valueSelect
      ? !(valueSelect?.slice().sort().join(',') === [...(value ?? [])].sort().join(','))
      : false;
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }, []);

  const selectedKeys = React.useMemo(() => selected.map((option) => option.key), [selected]);

  function onChange(event: any) {
    setSelected(event as Option[]);

    const keys = (event as any[])
      .map((option) => (typeof option === 'string' ? option : option.key))
      .filter(Boolean) as string[];
    const didChange = !([...keys].sort().join(',') === [...(value ?? [])].sort().join(','));
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }

  return (
    <Form.Group className={`mt-3 ${size}`}>
      <Form.Control type='hidden' name={name} value={JSON.stringify(selectedKeys)} />
      {showLabel && <Form.Label>{resolvedDisplayName}</Form.Label>}
      <Typeahead
        id={name}
        inputProps={{ id: name }}
        options={list}
        labelKey='value'
        onChange={onChange}
        selected={selected}
        isInvalid={errors[name] ? true : false}
        clearButton
        multiple
        highlightOnlyResult={true}
        disabled={disabled}
        placeholder={`--Select ${resolvedDisplayName}--`}
        emptyLabel='None Found...'
      />
      <Form.Control.Feedback type='invalid' className='d-block'>
        {errors[name]}
      </Form.Control.Feedback>
    </Form.Group>
  );
}
